import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'de',
        debug: process.env.NODE_ENV !== 'production',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        backend: {
            queryStringParams: { v: process.env.REACT_APP_VERSION },
        },
    });

export default i18n;
